import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
export function usePrivacyPolicyItem() {
    const { t } = useTranslation();
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    return {
        key: 'privacy-policy',
        label: t('siteHeader.userMenu.privacyPolicy'),
        link: Url.buildFromPath(URLS.PRIVACY),
        biData: BiData({
            evid: 702,
            link_url: Url.buildFromPath(URLS.PRIVACY),
            menu_item: 'privacy_policy',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}

//# sourceMappingURL=usePrivacyPolicyItem.js.map